module.exports = __webpack_public_path__ + "static/media/img-guide-covid19.7c5192ef.svg";